export default __webpack_public_path__ + "static/media/bg.2535fc4f.png";